import jwt_decode from 'jwt-decode';
import router from './router/router.js'
import { store } from './store.js';

export const ERROR_TYPE = {
    // Error type enum
    DEFAULT: 0,
    INTERNET: 1,
    AUTH: 2,
    INVALID: 3
}

export function handleError(error, msg) {
    console.error("Handling error:" + msg, error);

    router.push({ name: "Error" });

    if (!msg) {
        msg = "";
    }

    let userErrorMessage = msg;
    if (error.response.status == 403 || error.response.status == 401) {
        userErrorMessage += " Ingen tilgang.";
    }

    store.dispatch("setCurrentError", userErrorMessage);
}

export const notifyMixin = type => text => {
    return {
        group: 'notify',
        type: type,
        title: type === "error" ? "Det har oppstått en feil!" : "Advarsel",
        text: text
    }
}